import {Observable} from 'rxjs/Observable';
import get from 'lodash/get';
import {
    endPublishChallengeAction,
    endUnpublishChallengeAction,
    endValidateChallengeAction,
    errorPublishingChallengeAction,
    errorUnpublishingChallengeAction,
    errorValidatingChallengeAction,
    showPublishChallengeStatusModalAction,
    showUnpublishChallengeStatusModalAction,
    showValidateChallengeStatusModalAction,
    Types
} from "./actions";
import {validateBreak, publishBreak, unpublishBreak} from 'api/break-service';
import {saveResourceChangelistSuccess} from "../../resources/actions";
import {requestBreakAction} from 'pages/EditBreak/actions';
import * as ResourceApi from "../../api/resources";

export const parseValidationErrors = response => {
  const responseObject = get(response, 'object', {});

  // flatten map of arrays (keyed by platform) into one array
  const validationErrors = Object.keys(responseObject).reduce((errors, key) => errors.concat(responseObject[key]), []);

  return {
    success: validationErrors.length === 0,
    errors: validationErrors
  };
};

const publishChallengeEpic = ($action, store) => $action.ofType(Types.START_PUBLISH_CHALLENGE)
    .mergeMap((action) => publishBreak(action.challengeId, action.platforms)
        .mergeMap((response) => {
            const brk = action.brk;
            const {success, errors} = parseValidationErrors(response.response);

            const actions = [
                endPublishChallengeAction(),
                showPublishChallengeStatusModalAction(success, errors)
            ];

            if (success) {
                const now = Date.now();
                const breakStart = brk.startDate || now;
                const newStatus = breakStart <= now ? "LIVE" : "READY";

                // Modify both break and challenge records so they are up to date
                const saveBreakChangelistAction = saveResourceChangelistSuccess(
                    ResourceApi.Types.Break,
                    brk.id,
                    {
                        publishStatus: newStatus,
                        lastPublishedDate: now,
                        hasPendingChanges: false
                    },
                    brk.id
                );

                const saveChallengeChangelistAction = saveResourceChangelistSuccess(
                    ResourceApi.Types.Challenge,
                    action.challengeId,
                    {
                        [`breaks.${brk.platform}.publishStatus`]: newStatus,
                        [`breaks.${brk.platform}.lastPublishedDate`]: now,
                        [`breaks.${brk.platform}.hasPendingChanges`]: false,

                    },
                    action.challengeId
                );

                actions.push(
                    saveBreakChangelistAction,
                    saveChallengeChangelistAction,
                    requestBreakAction(action.challengeId)
                );
            }

            return Observable.of(...actions);
        })
        .catch(err => {
            const errorActions = [
                showPublishChallengeStatusModalAction(false)
            ];

            errorActions.push(
                err.xhr ? errorPublishingChallengeAction(err.response) : {
                    type: "ERROR",
                    error: err
                }
            );

            return Observable.of(...errorActions);
        })
    );

const unpublishChallengeEpic = ($action, store) => $action.ofType(Types.SUBMIT_UNPUBLISH_CHALLENGE)
    .mergeMap(() => {
            const breakPublish = store.getState().publishChallenge;

            const challengeId = breakPublish.unpublishingChallengeId;
            const platforms = breakPublish.platformsBeingUnpublished;
            const brk = breakPublish.unpublishingChallengeBreak;

            return unpublishBreak(challengeId, platforms)
                .mergeMap((response) => {
                    // NB: service API unpublish-break action does not run validations.

                    const successful = get(response, 'response.object', null);

                    const actions = [
                        endUnpublishChallengeAction(),
                        showUnpublishChallengeStatusModalAction(successful, null)
                    ];

                    if (successful) {
                        // Modify both break and challenge records so they are up to date
                        const saveBreakChangelistAction = saveResourceChangelistSuccess(
                            ResourceApi.Types.Break,
                            brk.id,
                            {
                                'publishStatus': "DRAFT"
                            },
                            brk.id
                        );

                        const saveChallengeChangelistAction = saveResourceChangelistSuccess(
                            ResourceApi.Types.Challenge,
                            challengeId,
                            {
                                [`breaks.${brk.platform}.publishStatus`]: 'DRAFT'
                            },
                            challengeId
                        );

                        // FIXME: These changelist-save actions above may be redundant now since
                        //        we're re-fetching the challenge after modifying its publishStatus.
                        //        Otherwise, the 'Unpublish' button in Master will have an incorrect
                        //        'disabled' state until after page refresh, if the page has already
                        //        been refreshed once.
                        actions.push(
                            saveBreakChangelistAction,
                            saveChallengeChangelistAction,
                            requestBreakAction(challengeId)
                        );
                    }

                    return Observable.of(...actions);
                })
                .catch(err => {
                    const errorActions = [
                        showUnpublishChallengeStatusModalAction(false)
                    ];

                    errorActions.push(
                        err.xhr ? errorUnpublishingChallengeAction(err.response) : {
                            type: "ERROR",
                            error: err
                        }
                    );

                    return Observable.of(...errorActions);
                });
        }
    );

const validateChallengeEpic = action$ => action$.ofType(Types.START_VALIDATE_CHALLENGE_ACTION)
  .mergeMap(action => {
    const validation$ = validateBreak(action.challengeId, action.platforms);

    return validation$
      .mergeMap(({response}) => {
        const {errors, success} = parseValidationErrors(response);

        return Observable.of(
          endValidateChallengeAction(),
          showValidateChallengeStatusModalAction(success, errors)
        );
      })
      .catch(error => Observable.of(
        error.xhr ? errorValidatingChallengeAction(error.response) : {
          type: "ERROR",
          error
        }, showValidateChallengeStatusModalAction(false)
      ));
  });

export default [
    publishChallengeEpic,
    unpublishChallengeEpic,
    validateChallengeEpic
];



// WEBPACK FOOTER //
// ./public/pages/BreakPublish/epics.js